const TAB_KEYBOARD_PREV = ['ArrowLeft', 'ArrowUp'];
const TAB_KEYBOARD_NEXT = ['ArrowRight', 'ArrowDown'];

const setSelectedTab = (tabs, activeTab) => {
	tabs.forEach((tab) => {
		const isActive = tab.dataset.tab === activeTab;
		tab.classList.toggle('is-active', isActive);
		tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
		tab.setAttribute('tabindex', isActive ? '0' : '-1');
	});
};

const setSelectedPanel = (panels, activeTab) => {
	let activePanel = null;

	panels.forEach((panel) => {
		const isActive = panel.dataset.tab === activeTab;
		panel.classList.toggle('is-active', isActive);
		panel.hidden = !isActive;

		if (isActive) {
			activePanel = panel;
		}
	});

	return activePanel;
};

const updateToggle = (block, toggleButton, activePanel) => {
	if (!toggleButton) {
		return false;
	}

	const toggleWrap = toggleButton.closest('.benefits-toggle-wrap');
	const itemCount = Number(activePanel?.dataset.count || 0);
	const canCollapse = itemCount >= 9;
	const isExpanded = block.classList.contains('is-expanded');
	const label = toggleButton.querySelector('[data-js="member-benefits-toggle-label"]');

	if (toggleWrap) {
		toggleWrap.hidden = !canCollapse;
	}

	toggleButton.hidden = !canCollapse;

	if (!canCollapse) {
		block.classList.remove('is-expanded');
		toggleButton.setAttribute('aria-expanded', 'false');

		if (label) {
			label.textContent = 'See all benefits';
		}

		return false;
	}

	toggleButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

	if (label) {
		label.textContent = isExpanded ? 'Show fewer benefits' : 'See all benefits';
	}

	return true;
};

export default function whatYouGetAsAMemberBlock() {
	const blocks = document.querySelectorAll('[data-js="member-benefits-block"]');

	if (!blocks.length) return;

	blocks.forEach((block) => {
		const tabs = Array.from(block.querySelectorAll('[data-js="member-benefits-tab"]'));
		const panels = Array.from(block.querySelectorAll('[data-js="member-benefits-panel"]'));
		const toggleButton = block.querySelector('[data-js="member-benefits-toggle"]');

		if (!tabs.length || !panels.length) {
			return;
		}

		let activeTab = tabs.find((tab) => tab.classList.contains('is-active'))?.dataset.tab || tabs[0].dataset.tab;
		let prefersExpanded = false;

		const render = (nextTab, shouldFocus = false) => {
			if (!nextTab) {
				return;
			}

			activeTab = nextTab;

			setSelectedTab(tabs, activeTab);
			const activePanel = setSelectedPanel(panels, activeTab);
			const canCollapse = Number(activePanel?.dataset.count || 0) >= 9;

			block.classList.toggle('is-expanded', canCollapse && prefersExpanded);
			updateToggle(block, toggleButton, activePanel);

			if (shouldFocus) {
				tabs.find((tab) => tab.dataset.tab === activeTab)?.focus();
			}
		};

		tabs.forEach((tab, index) => {
			tab.addEventListener('click', () => {
				render(tab.dataset.tab);
			});

			tab.addEventListener('keydown', (event) => {
				if (TAB_KEYBOARD_PREV.includes(event.key)) {
					event.preventDefault();
					const previousIndex = (index - 1 + tabs.length) % tabs.length;
					render(tabs[previousIndex].dataset.tab, true);
				}

				if (TAB_KEYBOARD_NEXT.includes(event.key)) {
					event.preventDefault();
					const nextIndex = (index + 1) % tabs.length;
					render(tabs[nextIndex].dataset.tab, true);
				}

				if (event.key === 'Home') {
					event.preventDefault();
					render(tabs[0].dataset.tab, true);
				}

				if (event.key === 'End') {
					event.preventDefault();
					render(tabs[tabs.length - 1].dataset.tab, true);
				}
			});
		});

		if (toggleButton) {
			toggleButton.addEventListener('click', () => {
				const activePanel = panels.find((panel) => panel.dataset.tab === activeTab);
				const canCollapse = Number(activePanel?.dataset.count || 0) >= 9;

				if (!canCollapse) {
					return;
				}

				prefersExpanded = !prefersExpanded;
				block.classList.toggle('is-expanded', prefersExpanded);
				updateToggle(block, toggleButton, activePanel);
			});
		}

		render(activeTab);
	});
}
